import { paragraphInit, paragraphAnim, paragraphOut } from './timelines/paragraph';
import { buttonInit, buttonAnim, buttonOut } from './timelines/button';
import { listInit, listAnim, listOut } from './timelines/list';
import { booleanInit, booleanAnim, booleanOut } from './timelines/boolean';
import { rangeInit, rangeAnim, rangeOut } from './timelines/range';
import { gridHideInit, gridHideAnim, gridHideOut } from './timelines/gridHide';
import { feedbackInit, feedbackAnim } from './timelines/feedback';

const initials = new Map();

initials.set('paragraph', paragraphInit);
initials.set('button', buttonInit);
initials.set('list', listInit);
initials.set('boolean', booleanInit);
initials.set('range', rangeInit);
initials.set('grid-hide', gridHideInit);
initials.set('feedback', feedbackInit);

const animations = new Map();
animations.set('paragraph', paragraphAnim);
animations.set('paragraph-out', paragraphOut);
animations.set('button', buttonAnim);
animations.set('button-out', buttonOut);
animations.set('list', listAnim);
animations.set('list-out', listOut);
animations.set('boolean', booleanAnim);
animations.set('boolean-out', booleanOut);
animations.set('range', rangeAnim);
animations.set('range-out', rangeOut);
animations.set('grid-hide', gridHideAnim);
animations.set('grid-hide-out', gridHideOut);
animations.set('feedback', feedbackAnim);

export { initials, animations };
